// extracted by mini-css-extract-plugin
export default {"wrapper":"introduction_wrapper__0rcHc","button":"introduction_button__zAI2D"};